import React from 'react';
import './Service.scss';
import lang from '../../i18/lang';
import img_1 from "../../assets/gallery/services/projektovanje.jpg";
import img_2 from "../../assets/gallery/mostici/5.JPG";
import img_3 from "../../assets/gallery/mostici/9.JPG";

class Service extends React.Component {

    state = {
        slide: 1
    };

    selectSlide = slide => {
        this.setState({slide});
    };

    render() {
        return (
            <div id="usluge" className="service-wrapper" ref={this.props.ref_services}>
                <div className="service">
                    <div className="background">
                        <div hidden={this.state.slide !== 1} className="image">
                            <img src={img_1}/>
                        </div>
                        <div hidden={this.state.slide !== 2} className="image">
                            <img src={img_2}/>
                        </div>
                        <div hidden={this.state.slide !== 3} className="image">
                            <img src={img_3}/>
                        </div>
                    </div>
                    {/*<div className="separator"/>*/}
                    <div className="description-wrapper">
                        <div className="description">
                            <div className="m-b-80" hidden={this.state.slide !== 1}>
                                <h5>{lang.srb.section.service.nacrti_i_projektovanje.nad_naslov}</h5>
                                <h1>{lang.srb.section.service.nacrti_i_projektovanje.naslov}</h1>
                                <p>{lang.srb.section.service.nacrti_i_projektovanje.opis}</p>
                            </div>
                            <div className="m-b-80" hidden={this.state.slide !== 2}>
                                <h5>{lang.srb.section.service.izrada_i_kvalitet.nad_naslov}</h5>
                                <h1>{lang.srb.section.service.izrada_i_kvalitet.naslov}</h1>
                                <p>{lang.srb.section.service.izrada_i_kvalitet.opis}</p>
                            </div>
                            <div className="m-b-80" hidden={this.state.slide !== 3}>
                                <h5>{lang.srb.section.service.ugradnja_i_sigurnosne_provere.nad_naslov}</h5>
                                <h1>{lang.srb.section.service.ugradnja_i_sigurnosne_provere.naslov}</h1>
                                <p>{lang.srb.section.service.ugradnja_i_sigurnosne_provere.opis}</p>
                            </div>
                            <div className="slider">
                                <div className={this.state.slide === 1 ? 'background-white' : ''} onClick={() => this.selectSlide(1)}/>
                                <div className={this.state.slide === 2 ? 'background-white' : ''} onClick={() => this.selectSlide(2)}/>
                                <div className={this.state.slide === 3 ? 'background-white' : ''} onClick={() => this.selectSlide(3)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Service;